import { render } from "./singleQuoteLoader.vue?vue&type=template&id=7f815588&scoped=true&lang=true"
import script from "./singleQuoteLoader.vue?vue&type=script&lang=js"
export * from "./singleQuoteLoader.vue?vue&type=script&lang=js"

import "./singleQuoteLoader.vue?vue&type=style&index=0&id=7f815588&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f815588"]])

export default __exports__